query RefCode4($Ref4CodeFilter: Reference4CodeFilter) {
  reference4Codes(orderBy: REFERENCE_CODE_ASC, filter: $Ref4CodeFilter) {
    nodes {
      name
      referenceCode
    }
  }
}
